//
//
//
//
//
//
//
//
//
//
//
//
//

import RelativePopupElement from "../../mixins/RelativePopupElement";
import {Portal} from "portal-vue";

export default {
    name: 'Tooltip',

    mixins: [RelativePopupElement],

    components: {Portal},

    props: {

        // The text to display within the tooltip
        text: {
            type: String,
            default: null
        },

        // Whether to show the tooltip via click on touch devices since no hover event exists on touch devices
        withTouch: {
            type: Boolean,
            default: false
        },

        minWidth: {
            type: [String, Number],
            default: 120
        },

        maxWidth: {
            type: [String, Number],
            default: 240
        },
    },

    methods: {
        triggerTooltip(show) {
            if (this.withTouch || this.$device.isDesktop) {
                this.isActive = show;
            } else {
                this.isActive = false;
            }
        }
    }
}
